import 'slick-carousel';
import {navigInit} from './scripts/navig';
import {ajaxPostsInit} from './scripts/ajax-posts';
import {ajaxGalleryInit} from './scripts/ajax-gallery';
import {slickInit} from './scripts/slick';
import {acfInit} from './scripts/acf';

navigInit();
slickInit();
ajaxPostsInit();
ajaxGalleryInit();
acfInit();

jQuery(document).ready(function ( $ ) {

  // smooth scroll to ID
  $('.menu-item a[href*="#"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - 120 // choose what you need
    }, 500, 'linear');
  });

});